"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Mw = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "-225 -114 450 300", ...props },
    react_1.default.createElement("path", { d: "M-225-114h450v300h-450z" }),
    react_1.default.createElement("g", { fill: "#CE1126" },
        react_1.default.createElement("circle", { r: 64.5 }),
        react_1.default.createElement("path", { d: "M-225-14h450V86h-450z" }),
        react_1.default.createElement("g", { id: "mw_svg__e" },
            react_1.default.createElement("g", { id: "mw_svg__d" },
                react_1.default.createElement("g", { id: "mw_svg__c" },
                    react_1.default.createElement("g", { id: "mw_svg__b" },
                        react_1.default.createElement("path", { id: "mw_svg__a", d: "M0-102c-2.2 0-3 3.3-3 6.5 0 8 1 12 3 23.5 2.04-11.5 3-15.6 3-23.5 0-3.3-1-6.5-3-6.5" }),
                        react_1.default.createElement("use", { xlinkHref: "#mw_svg__a", transform: "rotate(5)" })),
                    react_1.default.createElement("use", { xlinkHref: "#mw_svg__b", transform: "rotate(10)" })),
                react_1.default.createElement("use", { xlinkHref: "#mw_svg__c", transform: "rotate(20)" })),
            react_1.default.createElement("use", { xlinkHref: "#mw_svg__d", transform: "rotate(40)" })),
        react_1.default.createElement("use", { xlinkHref: "#mw_svg__e", transform: "rotate(-80)" })),
    react_1.default.createElement("path", { d: "M-225-21.5h450v7.5h-450z" }),
    react_1.default.createElement("path", { fill: "#339E35", d: "M-225 86h450v100h-450z" })));
exports.default = Mw;
//# sourceMappingURL=Mw.js.map